module.exports = __webpack_public_path__ + "static/media/dont-panic.18ab0281.png";